import React from 'react';
export function ConversationFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.808 2h9.284C20.422 2 22 3.202 22 4.908v6.323C22 12.6 20.6 14 19 14v2a1 1 0 01-1 1h-2.031a1 1 0 01-.835-.449L13.45 14h-3.442C8.312 13.961 7 12.656 7 10.93V4.909C7 3.633 8.158 2 9.808 2zM2 10v6c0 1.105.854 3 3 3v2a1 1 0 001 1h2.065a1 1 0 00.832-.445L10.6 19H14a1 1 0 00.8-1.6l-1.503-2.004a1 1 0 00-.791-.4l-3.533-.033a3 3 0 01-2.973-3V7.848c0-.489-.356-.922-.844-.914C2.809 6.968 2 9.006 2 10z"
  }));
}